import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-black border-t border-white/10 mt-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <Logo variant="footer" testId="footer-logo" />
          <p className="font-serif italic text-2xl md:text-3xl font-light leading-tight mt-8 max-w-md text-white/90" data-testid="footer-slogan">
            "Assets that Ground Us. Logistics that Move Us."
          </p>
          <p className="text-sm text-white/55 font-light mt-6 max-w-md">
            Tandem T Holdings LLC — building lasting value across logistics, real estate, and government services.
          </p>
          <div className="mt-8 flex flex-wrap gap-2">
            <span className="overline px-3 py-2 border border-white/20 text-white/80">Minority-Owned</span>
            <span className="overline px-3 py-2 border border-white/20 text-white/80">Woman-Owned</span>
            <span className="overline px-3 py-2 border border-white/20 text-white/80">Federally Aligned</span>
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="overline text-white/50 mb-5">Divisions</p>
          <ul className="space-y-3 text-sm">
            <li><Link to="/logistics" data-testid="footer-link-logistics" className="text-white/80 hover:text-white">Tandem T Logistics</Link></li>
            <li><Link to="/properties" data-testid="footer-link-properties" className="text-white/80 hover:text-white">Tandem T Properties</Link></li>
            <li><Link to="/government" data-testid="footer-link-government" className="text-white/80 hover:text-white">Government Contracting</Link></li>
            <li><Link to="/partnerships" data-testid="footer-link-partnerships" className="text-white/80 hover:text-white">Partnerships</Link></li>
            <li><Link to="/diversity" data-testid="footer-link-diversity" className="text-white/80 hover:text-white">Supplier Diversity</Link></li>
            <li><Link to="/letter" data-testid="footer-link-letter" className="text-white/80 hover:text-white">Founders&rsquo; Letter</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="overline text-white/50 mb-5">Contact</p>
          <ul className="space-y-4 text-sm text-white/80">
            <li className="flex items-start gap-3">
              <Mail size={14} className="mt-1 shrink-0" />
              <a href="mailto:partnerships@tandemtholdings.com" data-testid="footer-email" className="hover:text-white">partnerships@tandemtholdings.com</a>
            </li>
            <li className="flex items-start gap-3">
              <Phone size={14} className="mt-1 shrink-0" />
              <a href="tel:+16562566532" data-testid="footer-phone" className="hover:text-white">(656) 256-6532</a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={14} className="mt-1 shrink-0" />
              <div data-testid="footer-address">
                <p className="overline text-[10px] text-white/45">Corporate HQ</p>
                <p className="mt-1">550 N. Reo St., Suite 300<br />Tampa, FL 33609</p>
              </div>
            </li>
          </ul>
          <Link
            to="/contact?intent=government"
            data-testid="footer-contact-cta"
            className="group inline-flex items-center gap-3 mt-8 overline px-5 py-3 border border-white/30 hover:bg-white hover:text-black transition-colors"
          >
            Request Capabilities Statement
            <span className="hover-arrow">→</span>
          </Link>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-white/40">
          <p>© {new Date().getFullYear()} Tandem T Holdings LLC. All rights reserved.</p>
          <p className="font-serif italic">Integrity. Excellence. Legacy.</p>
        </div>
      </div>
    </footer>
  );
}
